import { SvgIcon, SvgIconProps } from '@mui/material';

const PointsOutlined = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="PointsOutlinedIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 12C19.4477 12 19 12.4477 19 13C19 13.5523 19.4477 14 20 14C20.5523 14 21 13.5523 21 13C21 12.4477 20.5523 12 20 12ZM17 13C17 11.3431 18.3431 10 20 10C21.6569 10 23 11.3431 23 13C23 14.6569 21.6569 16 20 16C18.3431 16 17 14.6569 17 13Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 7C4.44772 7 4 7.44772 4 8C4 8.55228 4.44772 9 5 9C5.55228 9 6 8.55228 6 8C6 7.44772 5.55228 7 5 7ZM2 8C2 6.34315 3.34315 5 5 5C6.65685 5 8 6.34315 8 8C8 9.65685 6.65685 11 5 11C3.34315 11 2 9.65685 2 8Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 19C16.4477 19 16 19.4477 16 20C16 20.5523 16.4477 21 17 21C17.5523 21 18 20.5523 18 20C18 19.4477 17.5523 19 17 19ZM14 20C14 18.3431 15.3431 17 17 17C18.6569 17 20 18.3431 20 20C20 21.6569 18.6569 23 17 23C15.3431 23 14 21.6569 14 20Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 15C6.89543 15 6 15.8954 6 17C6 18.1046 6.89543 19 8 19C9.10457 19 10 18.1046 10 17C10 15.8954 9.10457 15 8 15ZM4 17C4 14.7909 5.79086 13 8 13C10.2091 13 12 14.7909 12 17C12 19.2091 10.2091 21 8 21C5.79086 21 4 19.2091 4 17Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 3C12.3431 3 11 4.34315 11 6C11 7.65685 12.3431 9 14 9C15.6569 9 17 7.65685 17 6C17 4.34315 15.6569 3 14 3ZM9 6C9 3.23858 11.2386 1 14 1C16.7614 1 19 3.23858 19 6C19 8.76142 16.7614 11 14 11C11.2386 11 9 8.76142 9 6Z"
      />
    </SvgIcon>
  );
};

export default PointsOutlined;
